import React from "react";
import { Box, Grid, Button, FormGroup } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";

export default function LoadFIleView(props) {
  return (
    <Box
      sx={{
        bgcolor: "background.default",
        color: "text.primary",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Grid
        container
        sx={{
          top: 0,
          bottom: 0,
          marginTop: "12%",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid item xs={3}>
          <FormGroup>
            <Box mt={2}>
              <Button
                variant="contained"
                component="label"
                endIcon={<UploadIcon />}
              >
                Carregar Arquivo OFX{/* trad */}
                <input
                  id="file"
                  type="file"
                  hidden
                  onChange={(e) => props.handleUploadFile(e)}
                  onClick={(e) => {
                    e.target.value = null;
                  }}
                />
              </Button>
            </Box>
          </FormGroup>
        </Grid>
      </Grid>
    </Box>
  );
}
